interface MetricCardProps {
  label: string;
  value: string | number;
  /** When true, renders with an amber warning style (e.g. a metric below its healthy threshold). */
  warn?: boolean;
  /**
   * Optional native-tooltip caveat (rendered as the outer div's `title`
   * attribute — same pattern already used for `RecentVisitsTable`'s
   * `landingUrl` cell in AttributionPage.tsx). For a metric whose plain
   * number invites a misleading comparison (e.g. "Install (cookie-stitch)"
   * vs. the Chrome Web Store's own install count — see
   * `attribution_stats_service.compute_attribution_summary`'s docstring,
   * backend), this is where that caveat is surfaced to the human actually
   * reading the dashboard, not just to a future code-reader.
   */
  hint?: string;
}

function slug(label: string): string {
  return label.toLowerCase().replace(/[^a-z0-9]+/g, "-");
}

export function MetricCard({ label, value, warn = false, hint }: MetricCardProps) {
  return (
    <div
      data-testid={`metric-card-${slug(label)}`}
      title={hint}
      className={
        warn
          ? "bg-amber-50 rounded-lg border border-amber-300 p-6 shadow-sm hover:shadow-md transition-shadow"
          : "bg-white rounded-lg border border-slate-200 p-6 shadow-sm hover:shadow-md transition-shadow"
      }
    >
      <div className={`text-3xl font-bold ${warn ? "text-amber-800" : "text-slate-900"}`}>
        {value}
      </div>
      <div
        className={`text-xs font-medium uppercase tracking-wide mt-2 ${
          warn ? "text-amber-700" : "text-slate-500"
        }`}
      >
        {label}
      </div>
    </div>
  );
}
